'use strict';

window.TES = window.TES || {};

window.TES.moderateReview = function () {

    var $review = $(this).parents('tr').find('.reviewText'),
        id = $review.attr('id').replace('comment-', '');

    $.ajax({
        dataType: 'html',
        type: 'POST',
        url: '/api/review/' + id + '/moderate',
        success: function() { $review.parents('tr').addClass('moderated'); }
    });

    return false;
};

$(function () {
    $('.moderate-comment').on('click', window.TES.moderateReview);
});


